import keyBy from 'lodash/keyBy';
import { HYDRATE } from 'next-redux-wrapper';

import {
    IArticle,
    ICategory,
    ICategoryBase,
} from '@r1-frontend/api-domru/content-static/v1/faq/categories/dto/ResponseDto';

import { ICategorySet } from '~/src/features/faq/store/actionCreators';
import * as ActionCreators from '~/src/features/faq/store/actionCreators';
import { InferValueTypes, THydrateAction } from '~/src/store';

import { EService } from './actionTypes';

export type TStages = 'unknown' | 'reload' | 'error' | 'loaded' | 'loaded-articles'| 'loading';

export const STAGE_HAS_ARTICLES = ['loaded', 'loaded-articles'];

export interface IPopularArticle extends IArticle {
    category : ICategoryBase,
}

export interface IServiceHelpFAQStore {
    stage: TStages,
    popularArticles: IPopularArticle[],
    categories: Record<string, ICategory> | null,
    categoryIds: string[],
    activeCategoryId: string | null,
    activeArticle: string | null,
    loadingStatus: {
        isPageLoading: boolean,
        isDataLoading: boolean,
    },
}

const INITIAL_STATE: IServiceHelpFAQStore = {
    stage: 'unknown',
    popularArticles: [],
    loadingStatus: {
        isPageLoading: false,
        isDataLoading: false,
    },
    categoryIds: [],
    categories: null,
    activeCategoryId: null,
    activeArticle: null,
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

interface IGetCategoryResult {
    categoriesObject: Record<string, ICategory>,
    categoryIds: string[],
}

const getCategories = (categories: ICategory[]): IGetCategoryResult => {
    const categoriesObject = keyBy(categories, '_id') || null;

    const order = categories?.map(category => category._id) || [];
    return { categoriesObject, categoryIds: order };
};

interface ISetCategoryResult {
    stage: TStages,
    categories: Record<string, ICategory>,
    categoryIds: string[],
}

const setCategory = ({ categories, stage }: ICategorySet): ISetCategoryResult => {
    const { categoriesObject, categoryIds } = getCategories(categories);

    return {
        stage,
        categories: categoriesObject,
        categoryIds,
    };
};

const serviceReducer = (state = INITIAL_STATE, action: TActions): IServiceHelpFAQStore => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                ...action.payload.serviceHelpFAQ,
            };
        case EService.FAQ_SET_STAGE:
            return {
                ...state,
                stage: action.payload,
            };
        case EService.FAQ_SET_CATEGORY:
            return {
                ...state,
                ...setCategory(action.payload),
            };
        case EService.FAQ_SET_POPULAR_ARTICLES:
            return {
                ...state,
                popularArticles: action.payload,
            };
        case EService.FAQ_SET_ACTIVE_CATEGORY:
            return {
                ...state,
                activeCategoryId: action.payload,
                activeArticle: null,
            };
        case EService.FAQ_SET_ACTIVE_ARTICLE:
            return {
                ...state,
                activeArticle: action.payload,
            };
        case EService.FAQ_SET_PAGE_LOADING:
            return {
                ...state,
                loadingStatus: {
                    ...state.loadingStatus,
                    isPageLoading: action.payload,
                },
            };
        case EService.FAQ_SET_DATA_LOADING:
            return {
                ...state,
                loadingStatus: {
                    ...state.loadingStatus,
                    isDataLoading: action.payload,
                },
            };
        case EService.FAQ_CLEAR_ACTIVE:
            return {
                ...state,
                loadingStatus: {
                    isPageLoading: false,
                    isDataLoading: false,
                },
                activeArticle: null,
                activeCategoryId: null,
            };
        default:
            return state;
    }
};

export default serviceReducer;
